import { render, staticRenderFns } from "./OTPVerifcation.vue?vue&type=template&id=fdbe83fe"
import script from "./OTPVerifcation.vue?vue&type=script&lang=js"
export * from "./OTPVerifcation.vue?vue&type=script&lang=js"
import style0 from "./OTPVerifcation.vue?vue&type=style&index=0&id=fdbe83fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports